import { FieldViewModel, IGenericAnalysis, selectMany, sortDates } from "../omnia"
import { IDataLayer, IDataLayerValue, ISoilService, LayerTypeId } from "../types"
import { IFieldSelectionViewModel } from "./types"

export function getSoilAnalysisFields(svc: ISoilService, layerYear: number) {

    return getFields(
        svc,
        "std",
        layerYear,
        id => svc.getFieldSoilAnalyses(id),
        () => svc.getSoilAnalysisLayers(true)
    )

}

export function getPcnAnalysisFields(svc: ISoilService, layerYear: number) {

    return getFields(
        svc,
        "pcn",
        layerYear,
        id => svc.getFieldPcnAnalysis(id),
        () => svc.getSoilLayers(true, [LayerTypeId.PcnAnalysis])
    )

}

function getFields(svc: ISoilService, type: string, layerYear: number, analysisProvider: (id: number) => IGenericAnalysis[], layerProvider: () => ng.IPromise<IDataLayer[]>) {

    return layerProvider().then(layers => {

        const fields = getFieldInfo(svc)

        return selectMany(fields.map(f => {

            const fieldAnalysis = (analysisProvider(f.fieldId) || [])
                .map(a => ({
                    AnalysisId: a["SoilAnlaysisId"] || a["PcnAnalysisId"],
                    AnalysisNumber: a.AnalysisNumber,
                    SamplingDate: a.SamplingDate,
                }))
                .sort((a, b) => sortDates(b.SamplingDate, a.SamplingDate))

            const analysis = fieldAnalysis[0]

            const fieldVm: IFieldSelectionViewModel =
            {
                id: type + ":" + String(f.fieldId),
                fieldId: f.fieldId,
                zoneId: null,
                zoneNumber: 0,
                fieldName: f.field.Name,
                description: f.fieldVm.description,
                currentCrop: f.currentCrop,
                previousCrop: f.previousCrop,
                analysisNumber: analysis && analysis.AnalysisNumber,
                analysisDate: analysis && analysis.SamplingDate,
                selected: false,
            }

            const fieldLayers = layers
                .filter(l => l.FieldId === f.fieldId)
                .filter(l => layerYear ? (l.FirstYearId <= layerYear) : true)
                .sort((a, b) => {
                    const yearDiff = (b.FirstYearId || 0) - (a.FirstYearId || 0)
                    return yearDiff || sortDates(b.Date, a.Date)
                })

            const layer = fieldLayers.length ? fieldLayers[0] : null;
            const zones = layer && layer.Zones || []

            const zoneVm = zones.map(z => {

                var zAnalysis = z.Value
                    ? fieldAnalysis.find(a => a.AnalysisId === (<IDataLayerValue>z.Value).Value)
                    : null;

                return ({
                    ...fieldVm,
                    id: type + ":" + String(f.fieldId) + '/' + String(z.DataLayerZoneId),
                    zoneId: z.DataLayerZoneId,
                    zoneNumber: z.Number,
                    // description: f.fieldVm.description + " - Zone " + z.Number,
                    description: f.fieldVm.fieldName + " - Zone " + z.Number,
                    soilAnalysis: zAnalysis ? zAnalysis.AnalysisNumber : null,
                    soilAnalysisDate: zAnalysis ? zAnalysis.SamplingDate : null,
                });

            })

            return [fieldVm].concat(zoneVm)

        }))

    })

}


function getFieldInfo(svc: ISoilService) {

    return svc.activeFields.map(f => {

        const cropping = f.fieldVm.croppings
            .filter(c => c.currentYear)
            .sort((a, b) => sortDates(a.cropping.StartDate, b.cropping.StartDate))

        const currentCropping: FieldViewModel = cropping.length ? cropping[0] : null;
        const currentCrop = currentCropping ? currentCropping.crop : null;

        let previousCropping = currentCropping
            ? f.fieldVm.croppings.filter(c => currentCropping.cropping.PreviousIds.indexOf(c.croppingId) !== -1)
            : f.fieldVm.croppings.filter((c: FieldViewModel) => c.cropping.YearId < svc.yearId);

        previousCropping = previousCropping.sort((a, b) => sortDates(a.cropping.StartDate, b.cropping.StartDate))

        const previousCrop = previousCropping.length ? previousCropping[0].crop : null;

        return {
            fieldVm: f,
            field: f.field,
            fieldId: f.fieldId,
            currentCrop,
            previousCrop
        }

    })

}
